import { combineReducers } from 'redux';

import { TRACKING_CONTAINER_GET_SUCCESS } from '../actions/trackingContainerAction';

const trackingContainer = (state = {isLoad:false, value:[], msg:''} , action) => {
  switch (action.type) {
    case TRACKING_CONTAINER_GET_SUCCESS:
      return {value:action.val, isLoad:action.load,  msg:action.msg};
    default:
      return state;
  }
};

const TrackingContainerReducer = combineReducers({
  trackingContainer
});

export default TrackingContainerReducer;